export const selectBranchTransactionList = (state) =>
  state.branchTransaction.branchTransactions;
export const selectBranchAccounts = (state) => state.branchTransaction.accounts;
export const selectBranchCode = (state) => state.branchTransaction.branchCode;
export const selectBranchLoading = (state) => state.branchTransaction.loading;
export const selectBranchError = (state) => state.branchTransaction.error;
export const selectToBranches = (state) => state.branchTransaction.toBranches;
